// extracted by mini-css-extract-plugin
export var noSpinners = "_oy-6";
export var percentageInput = "_oy-7";
export var variantColor1 = "_oy-0";
export var variantColor2 = "_oy-1";
export var variantColor3 = "_oy-2";
export var variantColor4 = "_oy-3";
export var variantColor5 = "_oy-4";
export var variantColor6 = "_oy-5";